import { render, staticRenderFns } from "./rescore-locations.vue?vue&type=template&id=0585e017&scoped=true&"
import script from "./rescore-locations.vue?vue&type=script&lang=js&"
export * from "./rescore-locations.vue?vue&type=script&lang=js&"
import style0 from "./rescore-locations.vue?vue&type=style&index=0&id=0585e017&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0585e017",
  null
  
)

export default component.exports